import PropTypes from "prop-types";
import { Button, Tour } from "antd";
import "./productTour.css";

const ProductTour = ({
    open,
    current,
    steps,
    onChange,
    onClose,
    onFinish,
    onSkip,
    skipLabel,
    progressLabel,
}) => {
    const isHeroStep = steps[current]?.className?.includes("product-tour-hero");

    return (
        <Tour
            open={open}
            current={current}
            steps={steps}
            onChange={onChange}
            onClose={onClose}
            onFinish={onFinish}
            disabledInteraction
            zIndex={2000}
            rootClassName={`product-tour${isHeroStep ? " product-tour-hero" : ""}`}
            className={`product-tour${isHeroStep ? " product-tour-hero" : ""}`}
            gap={{ offset: 6, radius: 12 }}
            mask={{ color: "rgba(24, 24, 68, 0.52)" }}
            scrollIntoViewOptions={{ behavior: "smooth", block: "nearest" }}
            indicatorsRender={(stepIndex, total) => (
                <div className="product-tour-progress" aria-label={progressLabel}>
                    <div className="product-tour-progress-track">
                        <div
                            className="product-tour-progress-fill"
                            style={{ width: `${((stepIndex + 1) / Math.max(total, 1)) * 100}%` }}
                        />
                    </div>
                    <span className="product-tour-progress-count">
                        {stepIndex + 1}/{total}
                    </span>
                </div>
            )}
            actionsRender={(originNode, { current: stepIndex, total }) => (
                <>
                    {stepIndex !== total - 1 ? (
                        <Button size="small" type="text" onClick={onSkip}>
                            {skipLabel}
                        </Button>
                    ) : null}
                    {originNode}
                </>
            )}
        />
    );
};

ProductTour.propTypes = {
    open: PropTypes.bool.isRequired,
    current: PropTypes.number.isRequired,
    steps: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onSkip: PropTypes.func.isRequired,
    skipLabel: PropTypes.string.isRequired,
    progressLabel: PropTypes.string,
};

export default ProductTour;
